import axiosInstance from '../../../../../services/axios/axios';
import { then } from '../../../../../services/axios/_utility';

export const fetchJobCategoryData = async (queryParam, dispatch) => {
	return await axiosInstance
		.get('api/Applications/EpicHP/JobCategories', {
			params: {
				value: queryParam,
			},
		})
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};
